import axios from 'axios';
import { API_URL } from './api';

axios.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const AUTH_TOKEN_KEY = 'haique-auth-token';
export const AUTH_USER_KEY = 'haique-auth-user';

export function getStoredToken() {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function persistAuth(token, user) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user || {}));
}

export function clearAuth() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
}

export function applyAuthHeader(token) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
}

export async function loginRequest(username, password) {
  const res = await axios.post(`${API_URL}/api/auth/login`, { username, password });
  const body = res.data;
  if (body?.success && body?.data?.token) {
    return body.data;
  }
  throw new Error(body?.error || body?.detail || body?.message || 'Login failed');
}

export async function fetchAuthStatus() {
  const res = await axios.get(`${API_URL}/api/auth/status`);
  const body = res.data;
  const data = body?.data || {};
  return {
    loginRequired: data.login_required !== false,
    configured: data.configured !== false,
  };
}

export async function verifySession(token) {
  const res = await axios.get(`${API_URL}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const body = res.data;
  if (body?.success && body?.data?.username) {
    return body.data;
  }
  throw new Error('Session expired');
}
